/**
 *  Класс для регистрации блоков
 */
class Registration {
	static _blocks = [];

	/**
	 * 
	 */
	static blocksInit(container = document) {
		this._blocks.forEach(block => {
			const elements = container.querySelectorAll(`.${block.name}:not([data-initialized])`);
			if (elements.length > 0) {
				elements.forEach(elem => {
					new block.class(elem, block.name).onInit();
					elem.setAttribute('data-initialized', 'true');
				});
			}
		});
	}

	/**
	 * 
	 * @param {*} name 
	 * @param {*} instance 
	 */
	static blockRegister(name, instance) {
		this._blocks.push({
			name: name,
			class: instance
		});
	}
}

export default Registration;
